/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Rock&Run Admin API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult
} from '@tanstack/react-query';

import type {
	AccessTokenResponseDto,
	AdminListResponseDto,
	AdminLoginResponseDto,
	AdminResponseDto,
	AdminsControllerFindAllV1Params,
	AdminsControllerGetAuditLogsV1Params,
	AuditLogResponseDto,
	ChangePasswordDto,
	ChangePasswordResponseDto,
	CheckEmailDto,
	CheckEmailResponseDto,
	DeleteAdminResponseDto,
	FindAdminEmailDto,
	FindAdminEmailResponseDto,
	InitialPasswordChangeDto,
	InitialPasswordChangeResponseDto,
	LoginDto,
	MessageResponseDto,
	RegisterAdminDto,
	ResetAdminPasswordDto,
	ResetAdminPasswordResponseDto,
	UnlockAccountDto,
	UnlockAccountResponseDto,
	UpdateAdminDto,
	UpdateAdminResponseDto,
	UpdateMyProfileDto,
	UpdateMyProfileResponseDto
} from '../model';

import { axiosInstance } from '../../axiosInstance.ts';

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
	const result = { queryKey } as T & { queryKey: K };
	for (const key of Object.keys(query)) {
		// The explicit queryKey always wins, matching the previous
		// `{ ...query, queryKey }` spread where it was set last.
		if (key === 'queryKey') continue;
		Object.defineProperty(result, key, {
			enumerable: true,
			configurable: true,
			get: () => (query as Record<string, unknown>)[key]
		});
	}
	return result;
};

/**
 * 관리자 등록 시 이메일 중복 여부 확인
 * @summary 이메일 중복 확인
 */
export const adminsControllerCheckEmailV1 = (checkEmailDto: CheckEmailDto, signal?: AbortSignal) => {
	return axiosInstance<CheckEmailResponseDto>({
		url: `/v1/admins/check-email`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: checkEmailDto,
		signal
	});
};

export const getAdminsControllerCheckEmailV1MutationOptions = <TError = unknown, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<Awaited<ReturnType<typeof adminsControllerCheckEmailV1>>, TError, { data: CheckEmailDto }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof adminsControllerCheckEmailV1>>, TError, { data: CheckEmailDto }, TContext> => {
	const mutationKey = ['adminsControllerCheckEmailV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminsControllerCheckEmailV1>>, { data: CheckEmailDto }> = props => {
		const { data } = props ?? {};

		return adminsControllerCheckEmailV1(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type AdminsControllerCheckEmailV1MutationResult = NonNullable<Awaited<ReturnType<typeof adminsControllerCheckEmailV1>>>;
export type AdminsControllerCheckEmailV1MutationBody = CheckEmailDto;
export type AdminsControllerCheckEmailV1MutationError = unknown;

/**
 * @summary 이메일 중복 확인
 */
export const useAdminsControllerCheckEmailV1 = <TError = unknown, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<Awaited<ReturnType<typeof adminsControllerCheckEmailV1>>, TError, { data: CheckEmailDto }, TContext>;
	},
	queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof adminsControllerCheckEmailV1>>, TError, { data: CheckEmailDto }, TContext> => {
	return useMutation(getAdminsControllerCheckEmailV1MutationOptions(options), queryClient);
};
/**
 * MASTER 또는 AAA 등급 관리자가 새로운 관리자를 등록
 * @summary 관리자 등록 (MASTER, AAA 전용)
 */
export const adminsControllerRegisterV1 = (registerAdminDto: RegisterAdminDto, signal?: AbortSignal) => {
	return axiosInstance<AdminLoginResponseDto>({
		url: `/v1/admins/register`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: registerAdminDto,
		signal
	});
};

export const getAdminsControllerRegisterV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<Awaited<ReturnType<typeof adminsControllerRegisterV1>>, TError, { data: RegisterAdminDto }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof adminsControllerRegisterV1>>, TError, { data: RegisterAdminDto }, TContext> => {
	const mutationKey = ['adminsControllerRegisterV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminsControllerRegisterV1>>, { data: RegisterAdminDto }> = props => {
		const { data } = props ?? {};

		return adminsControllerRegisterV1(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type AdminsControllerRegisterV1MutationResult = NonNullable<Awaited<ReturnType<typeof adminsControllerRegisterV1>>>;
export type AdminsControllerRegisterV1MutationBody = RegisterAdminDto;
export type AdminsControllerRegisterV1MutationError = void;

/**
 * @summary 관리자 등록 (MASTER, AAA 전용)
 */
export const useAdminsControllerRegisterV1 = <TError = void, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<Awaited<ReturnType<typeof adminsControllerRegisterV1>>, TError, { data: RegisterAdminDto }, TContext>;
	},
	queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof adminsControllerRegisterV1>>, TError, { data: RegisterAdminDto }, TContext> => {
	return useMutation(getAdminsControllerRegisterV1MutationOptions(options), queryClient);
};
/**
 * @summary 관리자 로그인
 */
export const adminsControllerLoginV1 = (loginDto: LoginDto, signal?: AbortSignal) => {
	return axiosInstance<AdminLoginResponseDto>({
		url: `/v1/admins/login`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: loginDto,
		signal
	});
};

export const getAdminsControllerLoginV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<Awaited<ReturnType<typeof adminsControllerLoginV1>>, TError, { data: LoginDto }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof adminsControllerLoginV1>>, TError, { data: LoginDto }, TContext> => {
	const mutationKey = ['adminsControllerLoginV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminsControllerLoginV1>>, { data: LoginDto }> = props => {
		const { data } = props ?? {};

		return adminsControllerLoginV1(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type AdminsControllerLoginV1MutationResult = NonNullable<Awaited<ReturnType<typeof adminsControllerLoginV1>>>;
export type AdminsControllerLoginV1MutationBody = LoginDto;
export type AdminsControllerLoginV1MutationError = void;

/**
 * @summary 관리자 로그인
 */
export const useAdminsControllerLoginV1 = <TError = void, TContext = unknown>(
	options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof adminsControllerLoginV1>>, TError, { data: LoginDto }, TContext> },
	queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof adminsControllerLoginV1>>, TError, { data: LoginDto }, TContext> => {
	return useMutation(getAdminsControllerLoginV1MutationOptions(options), queryClient);
};
/**
 * httpOnly 쿠키의 Refresh Token으로 새로운 Access Token을 발급
 * @summary 토큰 갱신
 */
export const adminsControllerRefreshTokenV1 = (signal?: AbortSignal) => {
	return axiosInstance<AccessTokenResponseDto>({ url: `/v1/admins/refresh`, method: 'POST', signal });
};

export const getAdminsControllerRefreshTokenV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<Awaited<ReturnType<typeof adminsControllerRefreshTokenV1>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof adminsControllerRefreshTokenV1>>, TError, void, TContext> => {
	const mutationKey = ['adminsControllerRefreshTokenV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminsControllerRefreshTokenV1>>, void> = () => {
		return adminsControllerRefreshTokenV1();
	};

	return { mutationFn, ...mutationOptions };
};

export type AdminsControllerRefreshTokenV1MutationResult = NonNullable<Awaited<ReturnType<typeof adminsControllerRefreshTokenV1>>>;

export type AdminsControllerRefreshTokenV1MutationError = void;

/**
 * @summary 토큰 갱신
 */
export const useAdminsControllerRefreshTokenV1 = <TError = void, TContext = unknown>(
	options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof adminsControllerRefreshTokenV1>>, TError, void, TContext> },
	queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof adminsControllerRefreshTokenV1>>, TError, void, TContext> => {
	return useMutation(getAdminsControllerRefreshTokenV1MutationOptions(options), queryClient);
};
/**
 * Redis 세션 및 Refresh Token 쿠키를 삭제
 * @summary 로그아웃
 */
export const adminsControllerLogoutV1 = (signal?: AbortSignal) => {
	return axiosInstance<MessageResponseDto>({ url: `/v1/admins/logout`, method: 'POST', signal });
};

export const getAdminsControllerLogoutV1MutationOptions = <TError = unknown, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<Awaited<ReturnType<typeof adminsControllerLogoutV1>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof adminsControllerLogoutV1>>, TError, void, TContext> => {
	const mutationKey = ['adminsControllerLogoutV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminsControllerLogoutV1>>, void> = () => {
		return adminsControllerLogoutV1();
	};

	return { mutationFn, ...mutationOptions };
};

export type AdminsControllerLogoutV1MutationResult = NonNullable<Awaited<ReturnType<typeof adminsControllerLogoutV1>>>;

export type AdminsControllerLogoutV1MutationError = unknown;

/**
 * @summary 로그아웃
 */
export const useAdminsControllerLogoutV1 = <TError = unknown, TContext = unknown>(
	options?: { mutation?: UseMutationOptions<Awaited<ReturnType<typeof adminsControllerLogoutV1>>, TError, void, TContext> },
	queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof adminsControllerLogoutV1>>, TError, void, TContext> => {
	return useMutation(getAdminsControllerLogoutV1MutationOptions(options), queryClient);
};
/**
 * 현재 로그인한 관리자 정보 조회 (권한 포함)
 * @summary 내 정보 조회
 */
export const adminsControllerGetMyProfileV1 = (signal?: AbortSignal) => {
	return axiosInstance<AdminResponseDto>({ url: `/v1/admins/me`, method: 'GET', signal });
};

export const getAdminsControllerGetMyProfileV1QueryKey = () => {
	return [`/v1/admins/me`] as const;
};

export const getAdminsControllerGetMyProfileV1QueryOptions = <
	TData = Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>,
	TError = void
>(options?: {
	query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>, TError, TData>>;
}) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getAdminsControllerGetMyProfileV1QueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>> = ({ signal }) =>
		adminsControllerGetMyProfileV1(signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminsControllerGetMyProfileV1QueryResult = NonNullable<Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>>;
export type AdminsControllerGetMyProfileV1QueryError = void;

export function useAdminsControllerGetMyProfileV1<TData = Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>, TError = void>(
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>,
					TError,
					Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminsControllerGetMyProfileV1<TData = Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>, TError = void>(
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>,
					TError,
					Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminsControllerGetMyProfileV1<TData = Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>, TError = void>(
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 내 정보 조회
 */

export function useAdminsControllerGetMyProfileV1<TData = Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>, TError = void>(
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerGetMyProfileV1>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getAdminsControllerGetMyProfileV1QueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * 정렬 순서(최신순/오래된순)로 관리자 목록 조회. 이름 또는 이메일로 검색 가능
 * @summary 관리자 목록 조회
 */
export const adminsControllerFindAllV1 = (params?: AdminsControllerFindAllV1Params, signal?: AbortSignal) => {
	return axiosInstance<AdminListResponseDto>({ url: `/v1/admins`, method: 'GET', params, signal });
};

export const getAdminsControllerFindAllV1QueryKey = (params?: AdminsControllerFindAllV1Params) => {
	return [`/v1/admins`, ...(params ? [params] : [])] as const;
};

export const getAdminsControllerFindAllV1QueryOptions = <TData = Awaited<ReturnType<typeof adminsControllerFindAllV1>>, TError = void>(
	params?: AdminsControllerFindAllV1Params,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerFindAllV1>>, TError, TData>> }
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getAdminsControllerFindAllV1QueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof adminsControllerFindAllV1>>> = ({ signal }) =>
		adminsControllerFindAllV1(params, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof adminsControllerFindAllV1>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminsControllerFindAllV1QueryResult = NonNullable<Awaited<ReturnType<typeof adminsControllerFindAllV1>>>;
export type AdminsControllerFindAllV1QueryError = void;

export function useAdminsControllerFindAllV1<TData = Awaited<ReturnType<typeof adminsControllerFindAllV1>>, TError = void>(
	params: undefined | AdminsControllerFindAllV1Params,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerFindAllV1>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof adminsControllerFindAllV1>>,
					TError,
					Awaited<ReturnType<typeof adminsControllerFindAllV1>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminsControllerFindAllV1<TData = Awaited<ReturnType<typeof adminsControllerFindAllV1>>, TError = void>(
	params?: AdminsControllerFindAllV1Params,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerFindAllV1>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof adminsControllerFindAllV1>>,
					TError,
					Awaited<ReturnType<typeof adminsControllerFindAllV1>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminsControllerFindAllV1<TData = Awaited<ReturnType<typeof adminsControllerFindAllV1>>, TError = void>(
	params?: AdminsControllerFindAllV1Params,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerFindAllV1>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 관리자 목록 조회
 */

export function useAdminsControllerFindAllV1<TData = Awaited<ReturnType<typeof adminsControllerFindAllV1>>, TError = void>(
	params?: AdminsControllerFindAllV1Params,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerFindAllV1>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getAdminsControllerFindAllV1QueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * 관리자 활동 로그 조회 (카테고리별 필터, 기간 검색, 관리자 이름 검색)
 * @summary 시스템 로그 목록 조회
 */
export const adminsControllerGetAuditLogsV1 = (params?: AdminsControllerGetAuditLogsV1Params, signal?: AbortSignal) => {
	return axiosInstance<AuditLogResponseDto>({ url: `/v1/admins/audit-logs`, method: 'GET', params, signal });
};

export const getAdminsControllerGetAuditLogsV1QueryKey = (params?: AdminsControllerGetAuditLogsV1Params) => {
	return [`/v1/admins/audit-logs`, ...(params ? [params] : [])] as const;
};

export const getAdminsControllerGetAuditLogsV1QueryOptions = <
	TData = Awaited<ReturnType<typeof adminsControllerGetAuditLogsV1>>,
	TError = void
>(
	params?: AdminsControllerGetAuditLogsV1Params,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerGetAuditLogsV1>>, TError, TData>> }
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getAdminsControllerGetAuditLogsV1QueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof adminsControllerGetAuditLogsV1>>> = ({ signal }) =>
		adminsControllerGetAuditLogsV1(params, signal);

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof adminsControllerGetAuditLogsV1>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminsControllerGetAuditLogsV1QueryResult = NonNullable<Awaited<ReturnType<typeof adminsControllerGetAuditLogsV1>>>;
export type AdminsControllerGetAuditLogsV1QueryError = void;

export function useAdminsControllerGetAuditLogsV1<TData = Awaited<ReturnType<typeof adminsControllerGetAuditLogsV1>>, TError = void>(
	params: undefined | AdminsControllerGetAuditLogsV1Params,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerGetAuditLogsV1>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof adminsControllerGetAuditLogsV1>>,
					TError,
					Awaited<ReturnType<typeof adminsControllerGetAuditLogsV1>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminsControllerGetAuditLogsV1<TData = Awaited<ReturnType<typeof adminsControllerGetAuditLogsV1>>, TError = void>(
	params?: AdminsControllerGetAuditLogsV1Params,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerGetAuditLogsV1>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof adminsControllerGetAuditLogsV1>>,
					TError,
					Awaited<ReturnType<typeof adminsControllerGetAuditLogsV1>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminsControllerGetAuditLogsV1<TData = Awaited<ReturnType<typeof adminsControllerGetAuditLogsV1>>, TError = void>(
	params?: AdminsControllerGetAuditLogsV1Params,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerGetAuditLogsV1>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 시스템 로그 목록 조회
 */

export function useAdminsControllerGetAuditLogsV1<TData = Awaited<ReturnType<typeof adminsControllerGetAuditLogsV1>>, TError = void>(
	params?: AdminsControllerGetAuditLogsV1Params,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerGetAuditLogsV1>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getAdminsControllerGetAuditLogsV1QueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * 특정 관리자의 상세 정보 조회 (권한 포함)
 * @summary 관리자 상세 조회
 */
export const adminsControllerFindOneV1 = (adminId: number, signal?: AbortSignal) => {
	return axiosInstance<AdminResponseDto>({ url: `/v1/admins/${adminId}`, method: 'GET', signal });
};

export const getAdminsControllerFindOneV1QueryKey = (adminId: number) => {
	return [`/v1/admins/${adminId}`] as const;
};

export const getAdminsControllerFindOneV1QueryOptions = <TData = Awaited<ReturnType<typeof adminsControllerFindOneV1>>, TError = void>(
	adminId: number,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerFindOneV1>>, TError, TData>> }
) => {
	const { query: queryOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getAdminsControllerFindOneV1QueryKey(adminId);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof adminsControllerFindOneV1>>> = ({ signal }) =>
		adminsControllerFindOneV1(adminId, signal);

	return { queryKey, queryFn, enabled: adminId !== null && adminId !== undefined, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof adminsControllerFindOneV1>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminsControllerFindOneV1QueryResult = NonNullable<Awaited<ReturnType<typeof adminsControllerFindOneV1>>>;
export type AdminsControllerFindOneV1QueryError = void;

export function useAdminsControllerFindOneV1<TData = Awaited<ReturnType<typeof adminsControllerFindOneV1>>, TError = void>(
	adminId: number,
	options: {
		query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerFindOneV1>>, TError, TData>> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof adminsControllerFindOneV1>>,
					TError,
					Awaited<ReturnType<typeof adminsControllerFindOneV1>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminsControllerFindOneV1<TData = Awaited<ReturnType<typeof adminsControllerFindOneV1>>, TError = void>(
	adminId: number,
	options?: {
		query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerFindOneV1>>, TError, TData>> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof adminsControllerFindOneV1>>,
					TError,
					Awaited<ReturnType<typeof adminsControllerFindOneV1>>
				>,
				'initialData'
			>;
	},
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminsControllerFindOneV1<TData = Awaited<ReturnType<typeof adminsControllerFindOneV1>>, TError = void>(
	adminId: number,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerFindOneV1>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 관리자 상세 조회
 */

export function useAdminsControllerFindOneV1<TData = Awaited<ReturnType<typeof adminsControllerFindOneV1>>, TError = void>(
	adminId: number,
	options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminsControllerFindOneV1>>, TError, TData>> },
	queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getAdminsControllerFindOneV1QueryOptions(adminId, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * MASTER는 모든 관리자를, AAA는 자신보다 하위 등급(BBB, CCC, GUEST)의 관리자 정보를 수정 (등급, 권한 포함)
 * @summary 관리자 정보 수정 (MASTER, AAA 전용)
 */
export const adminsControllerUpdateAdminV1 = (adminId: number, updateAdminDto: UpdateAdminDto, signal?: AbortSignal) => {
	return axiosInstance<UpdateAdminResponseDto>({
		url: `/v1/admins/${adminId}`,
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		data: updateAdminDto,
		signal
	});
};

export const getAdminsControllerUpdateAdminV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof adminsControllerUpdateAdminV1>>,
		TError,
		{ adminId: number; data: UpdateAdminDto },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof adminsControllerUpdateAdminV1>>,
	TError,
	{ adminId: number; data: UpdateAdminDto },
	TContext
> => {
	const mutationKey = ['adminsControllerUpdateAdminV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof adminsControllerUpdateAdminV1>>,
		{ adminId: number; data: UpdateAdminDto }
	> = props => {
		const { adminId, data } = props ?? {};

		return adminsControllerUpdateAdminV1(adminId, data);
	};

	return { mutationFn, ...mutationOptions };
};

export type AdminsControllerUpdateAdminV1MutationResult = NonNullable<Awaited<ReturnType<typeof adminsControllerUpdateAdminV1>>>;
export type AdminsControllerUpdateAdminV1MutationBody = UpdateAdminDto;
export type AdminsControllerUpdateAdminV1MutationError = void;

/**
 * @summary 관리자 정보 수정 (MASTER, AAA 전용)
 */
export const useAdminsControllerUpdateAdminV1 = <TError = void, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof adminsControllerUpdateAdminV1>>,
			TError,
			{ adminId: number; data: UpdateAdminDto },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof adminsControllerUpdateAdminV1>>,
	TError,
	{ adminId: number; data: UpdateAdminDto },
	TContext
> => {
	return useMutation(getAdminsControllerUpdateAdminV1MutationOptions(options), queryClient);
};
/**
 * 마스터 관리자가 다른 관리자를 삭제 (본인은 삭제 불가)
 * @summary 관리자 삭제 (마스터 관리자 전용)
 */
export const adminsControllerDeleteAdminV1 = (adminId: number, signal?: AbortSignal) => {
	return axiosInstance<DeleteAdminResponseDto>({ url: `/v1/admins/${adminId}`, method: 'DELETE', signal });
};

export const getAdminsControllerDeleteAdminV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<Awaited<ReturnType<typeof adminsControllerDeleteAdminV1>>, TError, { adminId: number }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof adminsControllerDeleteAdminV1>>, TError, { adminId: number }, TContext> => {
	const mutationKey = ['adminsControllerDeleteAdminV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminsControllerDeleteAdminV1>>, { adminId: number }> = props => {
		const { adminId } = props ?? {};

		return adminsControllerDeleteAdminV1(adminId);
	};

	return { mutationFn, ...mutationOptions };
};

export type AdminsControllerDeleteAdminV1MutationResult = NonNullable<Awaited<ReturnType<typeof adminsControllerDeleteAdminV1>>>;

export type AdminsControllerDeleteAdminV1MutationError = void;

/**
 * @summary 관리자 삭제 (마스터 관리자 전용)
 */
export const useAdminsControllerDeleteAdminV1 = <TError = void, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<Awaited<ReturnType<typeof adminsControllerDeleteAdminV1>>, TError, { adminId: number }, TContext>;
	},
	queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof adminsControllerDeleteAdminV1>>, TError, { adminId: number }, TContext> => {
	return useMutation(getAdminsControllerDeleteAdminV1MutationOptions(options), queryClient);
};
/**
 * 이름과 휴대폰 번호로 관리자 이메일 찾기
 * @summary 관리자 이메일 찾기
 */
export const adminsControllerFindEmailV1 = (findAdminEmailDto: FindAdminEmailDto, signal?: AbortSignal) => {
	return axiosInstance<FindAdminEmailResponseDto>({
		url: `/v1/admins/find-email`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: findAdminEmailDto,
		signal
	});
};

export const getAdminsControllerFindEmailV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<Awaited<ReturnType<typeof adminsControllerFindEmailV1>>, TError, { data: FindAdminEmailDto }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof adminsControllerFindEmailV1>>, TError, { data: FindAdminEmailDto }, TContext> => {
	const mutationKey = ['adminsControllerFindEmailV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminsControllerFindEmailV1>>, { data: FindAdminEmailDto }> = props => {
		const { data } = props ?? {};

		return adminsControllerFindEmailV1(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type AdminsControllerFindEmailV1MutationResult = NonNullable<Awaited<ReturnType<typeof adminsControllerFindEmailV1>>>;
export type AdminsControllerFindEmailV1MutationBody = FindAdminEmailDto;
export type AdminsControllerFindEmailV1MutationError = void;

/**
 * @summary 관리자 이메일 찾기
 */
export const useAdminsControllerFindEmailV1 = <TError = void, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof adminsControllerFindEmailV1>>,
			TError,
			{ data: FindAdminEmailDto },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof adminsControllerFindEmailV1>>, TError, { data: FindAdminEmailDto }, TContext> => {
	return useMutation(getAdminsControllerFindEmailV1MutationOptions(options), queryClient);
};
/**
 * 이메일, 이름, 휴대폰 번호로 임시 비밀번호 발급 (만료시간 5분)
 * @summary 1회용 비밀번호 발급
 */
export const adminsControllerResetPasswordV1 = (resetAdminPasswordDto: ResetAdminPasswordDto, signal?: AbortSignal) => {
	return axiosInstance<ResetAdminPasswordResponseDto>({
		url: `/v1/admins/reset-password`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: resetAdminPasswordDto,
		signal
	});
};

export const getAdminsControllerResetPasswordV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof adminsControllerResetPasswordV1>>,
		TError,
		{ data: ResetAdminPasswordDto },
		TContext
	>;
}): UseMutationOptions<Awaited<ReturnType<typeof adminsControllerResetPasswordV1>>, TError, { data: ResetAdminPasswordDto }, TContext> => {
	const mutationKey = ['adminsControllerResetPasswordV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof adminsControllerResetPasswordV1>>,
		{ data: ResetAdminPasswordDto }
	> = props => {
		const { data } = props ?? {};

		return adminsControllerResetPasswordV1(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type AdminsControllerResetPasswordV1MutationResult = NonNullable<Awaited<ReturnType<typeof adminsControllerResetPasswordV1>>>;
export type AdminsControllerResetPasswordV1MutationBody = ResetAdminPasswordDto;
export type AdminsControllerResetPasswordV1MutationError = void;

/**
 * @summary 1회용 비밀번호 발급
 */
export const useAdminsControllerResetPasswordV1 = <TError = void, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof adminsControllerResetPasswordV1>>,
			TError,
			{ data: ResetAdminPasswordDto },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof adminsControllerResetPasswordV1>>, TError, { data: ResetAdminPasswordDto }, TContext> => {
	return useMutation(getAdminsControllerResetPasswordV1MutationOptions(options), queryClient);
};
/**
 * 마스터 관리자가 잠금된 관리자 계정을 해제 (본인 비밀번호 필요)
 * @summary 관리자 계정 잠금 해제 (마스터 관리자 전용)
 */
export const adminsControllerUnlockAccountV1 = (unlockAccountDto: UnlockAccountDto, signal?: AbortSignal) => {
	return axiosInstance<UnlockAccountResponseDto>({
		url: `/v1/admins/unlock-account`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: unlockAccountDto,
		signal
	});
};

export const getAdminsControllerUnlockAccountV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof adminsControllerUnlockAccountV1>>,
		TError,
		{ data: UnlockAccountDto },
		TContext
	>;
}): UseMutationOptions<Awaited<ReturnType<typeof adminsControllerUnlockAccountV1>>, TError, { data: UnlockAccountDto }, TContext> => {
	const mutationKey = ['adminsControllerUnlockAccountV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminsControllerUnlockAccountV1>>, { data: UnlockAccountDto }> = props => {
		const { data } = props ?? {};

		return adminsControllerUnlockAccountV1(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type AdminsControllerUnlockAccountV1MutationResult = NonNullable<Awaited<ReturnType<typeof adminsControllerUnlockAccountV1>>>;
export type AdminsControllerUnlockAccountV1MutationBody = UnlockAccountDto;
export type AdminsControllerUnlockAccountV1MutationError = void;

/**
 * @summary 관리자 계정 잠금 해제 (마스터 관리자 전용)
 */
export const useAdminsControllerUnlockAccountV1 = <TError = void, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof adminsControllerUnlockAccountV1>>,
			TError,
			{ data: UnlockAccountDto },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof adminsControllerUnlockAccountV1>>, TError, { data: UnlockAccountDto }, TContext> => {
	return useMutation(getAdminsControllerUnlockAccountV1MutationOptions(options), queryClient);
};
/**
 * 비밀번호 변경 180일 경과 또는 임시 비밀번호 발급 상태에서 현재 비밀번호와 새 비밀번호로 변경 (기존 세션 무효화)
 * @summary 관리자 비밀번호 변경
 */
export const adminsControllerChangePasswordV1 = (changePasswordDto: ChangePasswordDto, signal?: AbortSignal) => {
	return axiosInstance<ChangePasswordResponseDto>({
		url: `/v1/admins/change-password`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: changePasswordDto,
		signal
	});
};

export const getAdminsControllerChangePasswordV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof adminsControllerChangePasswordV1>>,
		TError,
		{ data: ChangePasswordDto },
		TContext
	>;
}): UseMutationOptions<Awaited<ReturnType<typeof adminsControllerChangePasswordV1>>, TError, { data: ChangePasswordDto }, TContext> => {
	const mutationKey = ['adminsControllerChangePasswordV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof adminsControllerChangePasswordV1>>,
		{ data: ChangePasswordDto }
	> = props => {
		const { data } = props ?? {};

		return adminsControllerChangePasswordV1(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type AdminsControllerChangePasswordV1MutationResult = NonNullable<Awaited<ReturnType<typeof adminsControllerChangePasswordV1>>>;
export type AdminsControllerChangePasswordV1MutationBody = ChangePasswordDto;
export type AdminsControllerChangePasswordV1MutationError = void;

/**
 * @summary 관리자 비밀번호 변경
 */
export const useAdminsControllerChangePasswordV1 = <TError = void, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof adminsControllerChangePasswordV1>>,
			TError,
			{ data: ChangePasswordDto },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof adminsControllerChangePasswordV1>>, TError, { data: ChangePasswordDto }, TContext> => {
	return useMutation(getAdminsControllerChangePasswordV1MutationOptions(options), queryClient);
};
/**
 * 최초 관리자 계정 생성 또는 임시 비밀번호 발급 후 새 비밀번호로 변경 (현재 비밀번호 불필요, 기존 세션 무효화)
 * @summary 최초 비밀번호 변경
 */
export const adminsControllerChangeInitialPasswordV1 = (initialPasswordChangeDto: InitialPasswordChangeDto, signal?: AbortSignal) => {
	return axiosInstance<InitialPasswordChangeResponseDto>({
		url: `/v1/admins/change-initial-password`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: initialPasswordChangeDto,
		signal
	});
};

export const getAdminsControllerChangeInitialPasswordV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof adminsControllerChangeInitialPasswordV1>>,
		TError,
		{ data: InitialPasswordChangeDto },
		TContext
	>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof adminsControllerChangeInitialPasswordV1>>,
	TError,
	{ data: InitialPasswordChangeDto },
	TContext
> => {
	const mutationKey = ['adminsControllerChangeInitialPasswordV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof adminsControllerChangeInitialPasswordV1>>,
		{ data: InitialPasswordChangeDto }
	> = props => {
		const { data } = props ?? {};

		return adminsControllerChangeInitialPasswordV1(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type AdminsControllerChangeInitialPasswordV1MutationResult = NonNullable<
	Awaited<ReturnType<typeof adminsControllerChangeInitialPasswordV1>>
>;
export type AdminsControllerChangeInitialPasswordV1MutationBody = InitialPasswordChangeDto;
export type AdminsControllerChangeInitialPasswordV1MutationError = void;

/**
 * @summary 최초 비밀번호 변경
 */
export const useAdminsControllerChangeInitialPasswordV1 = <TError = void, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof adminsControllerChangeInitialPasswordV1>>,
			TError,
			{ data: InitialPasswordChangeDto },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<
	Awaited<ReturnType<typeof adminsControllerChangeInitialPasswordV1>>,
	TError,
	{ data: InitialPasswordChangeDto },
	TContext
> => {
	return useMutation(getAdminsControllerChangeInitialPasswordV1MutationOptions(options), queryClient);
};
/**
 * 본인의 이름, 전화번호, 직책, 부서 정보 수정
 * @summary 내 프로필 정보 수정
 */
export const adminsControllerUpdateMyProfileV1 = (updateMyProfileDto: UpdateMyProfileDto, signal?: AbortSignal) => {
	return axiosInstance<UpdateMyProfileResponseDto>({
		url: `/v1/admins/me/profile`,
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		data: updateMyProfileDto,
		signal
	});
};

export const getAdminsControllerUpdateMyProfileV1MutationOptions = <TError = void, TContext = unknown>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof adminsControllerUpdateMyProfileV1>>,
		TError,
		{ data: UpdateMyProfileDto },
		TContext
	>;
}): UseMutationOptions<Awaited<ReturnType<typeof adminsControllerUpdateMyProfileV1>>, TError, { data: UpdateMyProfileDto }, TContext> => {
	const mutationKey = ['adminsControllerUpdateMyProfileV1'];
	const { mutation: mutationOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey } };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof adminsControllerUpdateMyProfileV1>>,
		{ data: UpdateMyProfileDto }
	> = props => {
		const { data } = props ?? {};

		return adminsControllerUpdateMyProfileV1(data);
	};

	return { mutationFn, ...mutationOptions };
};

export type AdminsControllerUpdateMyProfileV1MutationResult = NonNullable<Awaited<ReturnType<typeof adminsControllerUpdateMyProfileV1>>>;
export type AdminsControllerUpdateMyProfileV1MutationBody = UpdateMyProfileDto;
export type AdminsControllerUpdateMyProfileV1MutationError = void;

/**
 * @summary 내 프로필 정보 수정
 */
export const useAdminsControllerUpdateMyProfileV1 = <TError = void, TContext = unknown>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof adminsControllerUpdateMyProfileV1>>,
			TError,
			{ data: UpdateMyProfileDto },
			TContext
		>;
	},
	queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof adminsControllerUpdateMyProfileV1>>, TError, { data: UpdateMyProfileDto }, TContext> => {
	return useMutation(getAdminsControllerUpdateMyProfileV1MutationOptions(options), queryClient);
};
